import { useEffect } from 'react';
import NProgress from 'nprogress';
import { Box, alpha } from '@mui/material';
import { keyframes } from '@emotion/react';
import logo from 'src/assets/logo/logo.svg';

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const pulse = keyframes`
  0%, 100% { transform: scale(0.92); opacity: 0.75; }
  50% { transform: scale(1.05); opacity: 1; }
`;

function SuspenseLoader() {
  useEffect(() => {
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return (
    <Box
      sx={{
        position: 'fixed',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        backgroundColor: (theme) =>
          alpha(theme.palette.background.default, 0.7),
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        zIndex: (theme) => theme.zIndex.modal + 1
      }}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Box
        sx={{
          position: 'relative',
          width: 100,
          height: 100,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            border: '3px solid rgba(171, 109, 52, 0.15)',
            borderTopColor: '#AB6D34',
            animation: `${spin} 1s linear infinite`,
            '@media (prefers-reduced-motion: reduce)': {
              animation: 'none',
              borderTopColor: 'rgba(171, 109, 52, 0.4)'
            }
          }}
        />
        <Box
          component="img"
          src={logo}
          alt="Logo"
          sx={{
            width: 48,
            height: 48,
            animation: `${pulse} 1.8s ease-in-out infinite`,
            '@media (prefers-reduced-motion: reduce)': {
              animation: 'none'
            }
          }}
        />
      </Box>
    </Box>
  );
}

export default SuspenseLoader;
